import { ReactNode } from "react";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import CountColumn from "./CountColumn";
import { ListItemProps } from "./EditableListItem/EditableListItem";

type ItemsListProps = {
  title?: ReactNode;
  countColumn?: boolean;
  children?:
    | React.ReactElement<ListItemProps>
    | React.ReactElement<ListItemProps>[]
    | undefined;
};

const EditableItemsList = ({
  title,
  countColumn = true,
  className,
  children,
}: PropsWithClassName<ItemsListProps>) => {
  return (
    <div
      className={`overflow-hidden h-100 d-flex flex-column ${className ?? ""}`}
    >
      <header className="d-flex align-items-center app-shadow px-4 py-2">
        {countColumn && (
          <>
            <CountColumn count="#" />
            <span className="mx-1"></span>
          </>
        )}
        <p className="mb-0">{title}</p>
      </header>
      <ul className="m-0 p-0 list-unstyled px-4 overflow-auto">{children}</ul>
    </div>
  );
};

export default EditableItemsList;
